export default __webpack_public_path__ + "asset/img/icon-arrange-desc~153d42ed.png";